import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsamcoUserService } from '@asamco/base';
import { UserService } from '@asamco/user-management/shared';
import { FormHelpers, showErrorSwal } from '@asamco/utils';
import { CustomErrors } from 'libs/base/src/lib/as-validator/as-validator.directive';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { ContactFields } from '../interfaces/contact-fields.interface';
import { FileUploadContent } from '../interfaces/file-upload-content.interface';
import { MailHelperService } from '../services/mail-helper.service';
import { UsermanagementService } from '../services/usermanagement.service';
import { FileUploadTileComponent } from './file-upload-tile/file-upload-tile.component';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { AsValidatorDirective } from '../../../../../base/src/lib/as-validator/as-validator.directive';
import { DxTextBoxModule, DxTextAreaModule, DxFileUploaderModule } from 'devextreme-angular';

@Component({
    selector: 'app-shell-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, DxTextBoxModule, AsValidatorDirective, DxTextAreaModule, NgIf, DxFileUploaderModule, NgFor, FileUploadTileComponent, AsyncPipe]
})
export class ContactComponent implements OnInit {

  contactForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phoneNumber: new FormControl(''),
    question: new FormControl('',[Validators.required]),
    subject: new FormControl('',[Validators.required])
  });

  items: BehaviorSubject<Array<FileUploadContent>> = new BehaviorSubject<Array<FileUploadContent>>([])
  items$: Observable<Array<FileUploadContent>> = this.items.asObservable();

  sendingMail: BehaviorSubject<{value: boolean}> = new BehaviorSubject<{value: boolean}>({value: false})

  value: any[] = [];

  public customErrors: CustomErrors = {
		ERROR_REQUIRED: 'This field is required',
		ERROR_MAXLENGTH: 'This field exceeds the maximum allowed amount of characters',
	};

  constructor(private mailHelperService: MailHelperService) { 
  }

  ngOnInit(): void {
  }

  addData(dataObj: FileUploadContent) {
    const currentValue = this.items.value;
    const updatedValue = [...currentValue, dataObj];
    this.items.next(updatedValue);
  }

  removeData(data: FileUploadContent) {
    const itemsArr: FileUploadContent[] = this.items.value;

    itemsArr.forEach((item, index) => {
      if (item === data) { itemsArr.splice(index, 1); }
    });

    this.items.next(itemsArr);
  }

  sendMail() {
    let contactField: ContactFields;
    if (FormHelpers.validateForm(this.contactForm, contactField))
    {
      let contactField: ContactFields = this.contactForm.getRawValue();
      this.sendingMail.next({value: true});
      this.mailHelperService.postTestMail(this.items.value, contactField).subscribe(e => {
        this.sendingMail.next({value: false});
        this.clearAllContent();
        Swal.fire({icon: 'success',title: "Successfully sent email", text: "Assistance will be provided for you shortly."})
      }, error => {
        this.sendingMail.next({value: false});
        showErrorSwal(error)
      })
    }
  }

  clearAllContent() {
    this.items.next([]);
    this.contactForm.reset();
  }

  onFileDropped(event) {
    let maximumItemCount = 6;
    if (this.items.value.length > maximumItemCount) {
      Swal.fire({ title: "Maximum amount of attachments reached" })
    }
    else {

      let count = this.items.value.length;
      for(let element of event.value) {
        if(count > 6)
        {
          Swal.fire({ title: "Maximum amount of attachments reached" })
          continue;
        }
        else
        {
          if(element.size > 10000000)
          {
            Swal.fire({title: "Unable to upload file", text: "File :" + element.name + " exceeds 10mb limit"})
          }
          else
          {
            count = count + 1;
            let reader = new FileReader();
            reader.readAsDataURL(element);
    
            let fileUploadContent: FileUploadContent = {
              file: element,
              content: null,
            }
            reader.onload = (e) => {
              fileUploadContent.content = e.target.result;
              this.addData(fileUploadContent);
            };
          }
        }

      }
      };
  }



}

